export const VDPLAYER_SCRIPT_SRC =
    "https://player.vdocipher.com/v2/player.js";

/**
 * Ensures VdoCipher v2 web component script is loaded once.
 * @see https://www.vdocipher.com/docs/player/v2/webcomponent/#sample-embed-code
 */
export function loadVdocipherWebComponentPlayer() {
    return new Promise((resolve) => {
        if (typeof window === "undefined") {
            resolve();
            return;
        }

        if (window.customElements?.get?.("vdocipher-player")) {
            resolve();
            return;
        }

        let settled = false;
        const resolveOnce = () => {
            if (settled) return;
            settled = true;
            resolve();
        };

        let script = document.querySelector(
            `script[src="${VDPLAYER_SCRIPT_SRC}"]`
        );

        const onScriptLoad = () => {
            if (script) {
                script.dataset.vdocipherPlayerReady = "1";
            }
            resolveOnce();
        };

        if (script) {
            script.addEventListener("load", onScriptLoad);
            if (
                script.dataset.vdocipherPlayerReady === "1" ||
                window.customElements?.get?.("vdocipher-player")
            ) {
                onScriptLoad();
            }
            return;
        }

        script = document.createElement("script");
        script.src = VDPLAYER_SCRIPT_SRC;
        script.setAttribute("data-cfasync", "false");
        script.setAttribute("data-no-defer", "1");
        script.addEventListener("load", onScriptLoad);
        document.head.appendChild(script);
    });
}
